import { useContext } from 'react';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import useEnabledFeature from '../../useEnabledFeature';
import ABSegmentContext from '../../../components/ab-segment-context';

const useSortByRatings = (): boolean => {
  const { abbrBrand } = useContext(BrandInfoContext);
  const featureEnabled = useEnabledFeature('cat-star-ratings');

  const segments = useContext(ABSegmentContext);
  const sortByRatingsSegmentValue = segments[`${abbrBrand}87`];
  const sortByRatingsSegmentEnabled =
    sortByRatingsSegmentValue === 'b' || sortByRatingsSegmentValue === 'c';

  return featureEnabled && sortByRatingsSegmentEnabled;
};

export default useSortByRatings;
